"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthContext = exports.AuthContext = void 0;
const makeContextAndHook_1 = require("../utils/makeContextAndHook");
_a = (0, makeContextAndHook_1.makeContextAndHook)('AuthContext'), exports.AuthContext = _a[0], exports.useAuthContext = _a[1];
//# sourceMappingURL=AuthContext.js.map